import * as React from 'react';
import CommentHeader, {ICommentHeaderProp} from '../commentHeader';
import CommentMessage, {ICommentMessageProp} from '../commentMessage';
import CommentItemReply, {ICommentItemReplyProp} from './reply';
import CommentOption, {ICommentOptionProp} from '../commentOption';
import {L} from '../../../../lang';
import {ICommonCommentItem} from '../../../../apis/comment/commonApiAdapter';

if (process.env.BROWSER) {
    require('./index.less');
}
export interface ICommentItemProp {// props
  commentItem: ICommonCommentItem;
    id: string;
    headerProp: ICommentHeaderProp;
    messageProp: ICommentMessageProp;
    optionProp: ICommentOptionProp;
    replyItemProps?: ICommentItemReplyProp[];
    replyCount: number;
    onClickCommentItem?: (prop: ICommentItemProp) => void;
  isLocal: boolean;
  onLikeItem;
}
export default class CommentItem extends React.PureComponent<ICommentItemProp> {
    public render(): JSX.Element {
        return <div className={'comment-item'} onClick={this.onClickCommentItem} >
            <CommentHeader {... this.props.headerProp} ></CommentHeader>
            <CommentMessage {... this.props.messageProp} ></CommentMessage>
          {
            this.props.isLocal ? <div className="local-option-placeholder"></div> :
              <CommentOption commentItem={this.props.commentItem}
                             type="comment"
                             {...this.props.optionProp} ></CommentOption>
          }

            {
                this.props.replyItemProps ? this.renderReplies() : null
            }
        </div>;
    }

    private onClickCommentItem = () => {
        if (this.props.onClickCommentItem) {
            this.props.onClickCommentItem(this.props);
        }
    }

    private renderReplies = () => {
        if (this.props.replyItemProps.length > 0) {
            return <div className={'comment-item-replies'} >
                {
                    this.props.replyItemProps.map((prop, index) => {
                        return <CommentItemReply key={`${prop.id}/${index}`} {...prop} ></CommentItemReply>;
                    })
                }
                {
                    this.renderMoreCommentNode()
                }
            </div>;
        } else {
            return null;
        }
    }

    private renderMoreCommentNode = () => {
        const replyCount = this.props.replyCount;
        if (replyCount > this.props.replyItemProps.length) {
            return <div className={'comment-item-morereplies'}>
                {`${replyCount - this.props.replyItemProps.length} ${L('comment.x_more_reply')}`}
            </div>;
        }
        return null;
    }
}
